import { useAuth } from '../../contexts/auth'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFileLines} from "@fortawesome/free-solid-svg-icons";
import React, { useEffect, useState } from 'react';
import {verifyAccess, verifyParamMenu} from '../../utils/admin.utils';
import AccessDenied from '../../components/access-denied/access-denied';
import './dogovor.scss'
import {Button} from "devextreme-react/button";
import {useHistory} from "react-router-dom";
import {
    getFinInfoSum,
    getImminentPays,
    getOverpaySum,
    getPeniSum,
    getTaxSum
} from '../../api/dogovor';
import notify from 'devextreme/ui/notify';


const finNumber = (value) => {
    if (typeof value === 'number' && !Number.isNaN(value)) return value
    if (typeof value === 'string' && value.trim() !== '' && !Number.isNaN(+value)) return +value
    return 0
}

const DogovorActions = () => {
    const history = useHistory();
    const auth = useAuth()
    const dogovor = auth.selectedDog
    const [visiblePage, setVisiblePage] = useState(true)
    const [finInfoSum, setFinInfoSum] = useState(null)
    const formatMoney = (value) => (+(value || 0)).toLocaleString('ru', { style: "currency", currency: "RUB" })
    const formatToPay = (value) => formatMoney(Math.max(0, +(value || 0)))
    // «К оплате» приходит с бэкенда (for_pay_sum): из сумм документов вычтена переплата, не ниже нуля
    const payTotal = (fin) => fin?.for_pay_sum == null
        ? Math.max(0, finNumber(fin?.sum_dolg) + finNumber(fin?.sum_energy) + finNumber(fin?.sum_peni) + finNumber(fin?.sum_tax))
        : finNumber(fin.for_pay_sum)
    const formatDate = (value) => {
        if (!value) return null
        const d = new Date(value)
        if (!Number.isNaN(d.getTime())) {
            return d.toLocaleDateString('ru-RU')
        }
        return null
    }

    const payDateLabel = formatDate(finInfoSum?.date_pay)
    const isRenergy = process.env.REACT_APP_NAME_ENV === 'renergy'

    useEffect(() => {
        setVisiblePage(true)
        const pageRoles = [2,3]
        if (!verifyAccess(pageRoles, dogovor)){
            setVisiblePage(false)
            return
        }
        // ГП (2) и ФИКС (3)
        if (!verifyParamMenu([2, 3], dogovor)){
            setVisiblePage(false)
        }
    }, [dogovor])

    useEffect(() => {
        if (!isRenergy || !dogovor?.kodDog) {
            setFinInfoSum(null)
            return
        }
        (async function(){
            const [resFinInfo, resOverpay, resTax, resPeni, resImminent] = await Promise.all([
                getFinInfoSum(dogovor.kodDog),
                getOverpaySum(dogovor.kodDog),
                getTaxSum(dogovor.kodDog),
                getPeniSum(dogovor.kodDog),
                getImminentPays(dogovor.kodDog)
            ])

            const finData = resFinInfo.isOk ? (resFinInfo.data || {}) : {}
            if (!resFinInfo.isOk) notify(resFinInfo.message, 'error', 5000)

            setFinInfoSum({
                sum_dolg: finNumber(finData.sum_dolg),
                sum_energy: finNumber(finData.sum_energy),
                for_pay_sum: finData.for_pay_sum == null ? null : finNumber(finData.for_pay_sum),
                sum_overpay: resOverpay.isOk ? finNumber(resOverpay.data?.sum_overpay) : 0,
                sum_tax: resTax.isOk ? finNumber(resTax.data?.sum_tax) : 0,
                sum_peni: resPeni.isOk ? finNumber(resPeni.data?.sum_peni) : 0,
                sum_imminent: resImminent.isOk ? finNumber(resImminent.data?.sum_imminent) : 0,
                date_pay: finData.date_pay ?? null,
            })
        })()
    }, [dogovor, isRenergy])

    const onClickPokazania = async () => {
        history.push('/pokazania-new');
    }

    const onClickScheta = async () => {
        history.push('/docs');
    }

    return (
        <>{visiblePage ?
        <div className={'content-block dx-card responsive-paddings big-input dogovor-actions'}>
            {isRenergy && (
                <div className="row align-items-start mb-3">
                    <div className="col-lg-8 col-md-12">
                        <h4>
                            К оплате {payDateLabel ? `на ${payDateLabel}` : ''}: {formatToPay(payTotal(finInfoSum))}
                        </h4>
                        <h5>Электроэнергия: {formatMoney(finInfoSum?.sum_dolg)}</h5>
                        <h5>Пени: {formatMoney(finInfoSum?.sum_peni)}</h5>
                        <h5>Предстоящие платежи: {formatMoney(finInfoSum?.sum_energy)}</h5>
                        <h5>Госпошлина: {formatMoney(finInfoSum?.sum_tax)}</h5>
                    </div>
                    {/*<div className="col-lg-4 col-md-12 text-lg-right mt20md">
                        <Button
                            type={'default'}
                            className={'big-button'}
                            text="Оплатить"
                            icon="/images/ruble_solid_icon.svg"
                            onClick={() => history.push('/debt')}
                        />
                    </div>*/}
                </div>
            )}
            <div className="row">
                <div className="col-md-12">
                    <FontAwesomeIcon className="icon-header-h3 main-color main-color-light" icon={faFileLines} />
                    <h3><strong>Действия по договору</strong></h3>
                    <div className="row mt20">
                        {isRenergy &&
                            <>
                            <div className={'mb-2 col-12 col-sm-12 col-md-4 col-lg-3'}>
                                <Button type={'default'} className={'block big-button'} text="Передать показания" hint="Передать показания" icon="fieldchooser" onClick={onClickPokazania}/>
                            </div>
                            <div className={'mb-2 col-12 col-sm-12 col-md-4 col-lg-3'}>
                            <Button type={'default'} className={'block big-button'} text="Счета" hint="Счета" icon="datafield" onClick={onClickScheta}/>
                            </div>
                                <div className={'mb-2 col-12 col-sm-12 col-md-4 col-lg-3'}>
                                    <Button type={'default'} className={'block big-button'}  text="Оплатить" hint="Оплатить"  icon="/images/ruble_solid_icon.svg" onClick={() => history.push('/debt')}/>
                                </div>
                            </>
                        }
                    </div>
                </div>
            </div>
        </div>
        : <AccessDenied/>}</>
    )
}

export default DogovorActions
